<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8" content-class="custom-menu")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedOption" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold Religion
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ selectedReligion }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Religion
    
    .pa-4.white(style="border-radius: inherit;")
      .font-semibold.mb-3.text-sm {{ $t('filter_by') }} religion
      y-select.mb-2(v-model="option" :items="options" item-text="name" item-value="id" small attach placeholder="Select religion")
    
    .bottom-0.sticky.z-1.white(style="border-radius: inherit;")
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="option" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="!option") {{ $t('apply') }}


</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data: () => ({
    showMenu: false,
    option: null,
    selectedOption: null,
    options: [
      { name: 'Islam', id: 'islam' },
      { name: 'Buddha', id: 'buddha' },
      { name: 'Hindu', id: 'hindu' },
      { name: 'Christian', id: 'kristian' },
      { name: 'Others', id: 'others' },
    ],
  }),
  computed: {
    selectedReligion () {
      return this.options.find(option => option.id === this.selectedOption)?.name ?? null
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.option = this.filter.value
          this.selectedOption = this.filter.value
        }
      }
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.selectedOption = null
      this.option = null
    },
    apply () {
      this.showMenu = false
      this.selectedOption = this.option
      let key = 'religion'
      let value = this.option
      if (this.option === 'others') {
        key = 'exclude_religion'
        value = ['islam', 'buddha', 'hindu', 'kristian'].join(',')
      }
      const filter = { key , value }
      this.$emit('update:filter', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
::v-deep {
  .custom-menu {
    overflow: unset;
    contain: unset;
  }
}
</style>